/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetAodScheduledRunsScheduledRunsQueryResponse } from "../models/GetAodScheduledRunsScheduledRuns";

export function getGetAodScheduledRunsScheduledRunsUrl() {
  const res = { method: 'GET', url: `/aod-runs/scheduled` as const }
  return res
}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for all AOD rules belonging to the authenticated user's client
 * @summary Get all scheduled runs for the client
 * {@link /aod-runs/scheduled}
 */
export async function getAodScheduledRunsScheduledRuns(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetAodScheduledRunsScheduledRunsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetAodScheduledRunsScheduledRunsUrl().url.toString(), ... requestConfig })
  return res.data
}